var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "apply-list" },
    [
      _c(
        "el-row",
        { staticClass: "row", attrs: { type: "flex" } },
        [
          _c("el-col", { attrs: { span: _vm.signStatusSet !== "-2" ? 5 : 9 } }),
          _c(
            "el-col",
            { staticStyle: { "margin-right": "15px" }, attrs: { span: 7 } },
            [
              _c(
                "el-row",
                { attrs: { gutter: 10 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: { placeholder: "请选择", size: "small" },
                          model: {
                            value: _vm.selectParam,
                            callback: function($$v) {
                              _vm.selectParam = $$v
                            },
                            expression: "selectParam"
                          }
                        },
                        [
                          _c("el-option", {
                            attrs: { label: "文件名称", value: "contractName" }
                          }),
                          _c("el-option", {
                            attrs: {
                              label: "签署方",
                              value: "signatoryFullName"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c("el-input", {
                        attrs: { size: "small", placeholder: "查询内容" },
                        model: {
                          value: _vm.selectParamVal,
                          callback: function($$v) {
                            _vm.selectParamVal = $$v
                          },
                          expression: "selectParamVal"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm.signStatusSet !== "-2"
            ? _c("el-col", { attrs: { span: 4 } }, [
                _c(
                  "div",
                  {
                    staticStyle: {
                      "text-align": "center",
                      "white-space": "nowrap"
                    }
                  },
                  [
                    _c(
                      "el-select",
                      {
                        staticStyle: { width: "140px" },
                        attrs: { placeholder: "请选择", size: "small" },
                        model: {
                          value: _vm.selectedStatus,
                          callback: function($$v) {
                            _vm.selectedStatus = $$v
                          },
                          expression: "selectedStatus"
                        }
                      },
                      _vm._l(_vm.statusEnum, function(item, index) {
                        return _c("el-option", {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value:
                                !_vm.$route.query.notMeSign ||
                                (_vm.$route.query.notMeSign &&
                                  item.value !== "0"),
                              expression:
                                "\n                !$route.query.notMeSign ||\n                ($route.query.notMeSign && item.value !== '0')\n              "
                            }
                          ],
                          key: "status" + index,
                          attrs: { label: item.label, value: item.value }
                        })
                      }),
                      1
                    )
                  ],
                  1
                )
              ])
            : _vm._e(),
          _c(
            "el-col",
            { attrs: { span: 5 } },
            [
              _c("el-date-picker", {
                staticStyle: { width: "unset" },
                attrs: {
                  type: "daterange",
                  "value-format": "yyyy-MM-dd",
                  "default-time": ["00:00:00", "23:59:59"],
                  "range-separator": "至",
                  "start-placeholder": "开始日期",
                  "end-placeholder": "结束日期",
                  size: "small"
                },
                model: {
                  value: _vm.paramDateArr,
                  callback: function($$v) {
                    _vm.paramDateArr = $$v
                  },
                  expression: "paramDateArr"
                }
              })
            ],
            1
          ),
          _c(
            "el-col",
            { staticClass: "text-right", attrs: { span: 3 } },
            [
              _c(
                "el-row",
                { attrs: { type: "flex" } },
                [
                  _c(
                    "el-col",
                    { staticClass: "text-right", attrs: { span: 12 } },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { size: "small" },
                          on: { click: _vm.queryFilter }
                        },
                        [_vm._v("查询")]
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { staticClass: "text-right", attrs: { span: 12 } },
                    [
                      _c(
                        "el-button",
                        { attrs: { size: "small" }, on: { click: _vm.rest } },
                        [_vm._v("重置")]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm.signStatusSet === "-2"
        ? _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading"
                }
              ],
              key: "type6",
              ref: "dataList",
              staticClass: "data-list",
              staticStyle: { "min-height": "54vh" },
              attrs: {
                data: _vm.tableList,
                "tooltip-effect": "dark",
                "header-cell-style": {
                  background: "#f9f9f9",
                  color: "#333333",
                  fontWeight: "500"
                }
              },
              on: { "selection-change": _vm.handleSelectionChange }
            },
            [
              _c("el-table-column", {
                attrs: { type: "selection", width: "45" }
              }),
              _c("el-table-column", {
                attrs: {
                  label: "文件名称",
                  prop: "contractName",
                  "min-width": "300"
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function(scope) {
                        return [
                          _c(
                            "div",
                            {
                              staticStyle: {
                                display: "flex",
                                "align-items": "center",
                                position: "relative",
                                "padding-top": "10px"
                              }
                            },
                            [
                              scope.row.files > 1
                                ? _c("span", { staticClass: "multiFile" }, [
                                    _vm._v("多")
                                  ])
                                : _vm._e(),
                              !_vm.isInDingTalk
                                ? [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "custom-link textEllipsis",
                                        staticStyle: {
                                          "margin-right": "5px",
                                          opacity: "1"
                                        },
                                        attrs: { target: "_blank" },
                                        on: {
                                          click: function($event) {
                                            return _vm.toDetails(scope.row)
                                          }
                                        }
                                      },
                                      [
                                        _c(
                                          "el-tooltip",
                                          {
                                            attrs: {
                                              effect: "dark",
                                              content: scope.row.contractName,
                                              placement: "bottom-start"
                                            }
                                          },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticStyle: {
                                                  "font-size": "16px"
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(scope.row.contractName)
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    )
                                  ]
                                : [
                                    _c(
                                      "span",
                                      {
                                        staticClass: "custom-link textEllipsis",
                                        staticStyle: {
                                          "margin-right": "5px",
                                          opacity: "1"
                                        }
                                      },
                                      [
                                        _c(
                                          "el-tooltip",
                                          {
                                            attrs: {
                                              effect: "dark",
                                              content: scope.row.contractName,
                                              placement: "bottom-start"
                                            }
                                          },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticStyle: {
                                                  "font-size": "16px"
                                                },
                                                on: {
                                                  click: function($event) {
                                                    return _vm.dingTurn(
                                                      scope.row
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(scope.row.contractName)
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    )
                                  ]
                            ],
                            2
                          ),
                          _c("p", { staticClass: "textEllipsis" }, [
                            _vm._v("创建人：" + _vm._s(scope.row.ebqUserName))
                          ]),
                          _c("p", { staticClass: "textEllipsis" }, [
                            _vm._v(
                              "\n            创建时间：" +
                                _vm._s(
                                  _vm._f("formatDateHM")(scope.row.createTime)
                                ) +
                                "\n          "
                            )
                          ])
                        ]
                      }
                    }
                  ],
                  null,
                  false,
                  847367547
                )
              }),
              _c("el-table-column", {
                attrs: { label: "签署方", width: "300" },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function(scope) {
                        return [
                          _c(
                            "el-tooltip",
                            { attrs: { placement: "bottom-start" } },
                            [
                              _vm._l(scope.row.signInfoVOS, function(
                                item,
                                index
                              ) {
                                return _c(
                                  "div",
                                  {
                                    key: index,
                                    staticStyle: {
                                      display: "flex",
                                      "align-items": "center",
                                      "padding-bottom": "5px"
                                    },
                                    attrs: { slot: "content" },
                                    slot: "content"
                                  },
                                  [
                                    item.orderNum && item.orderNum >= 1
                                      ? _c(
                                          "span",
                                          {
                                            staticStyle: {
                                              display: "block",
                                              width: "13px",
                                              height: "13px",
                                              "border-radius": "50%",
                                              color: "#ffffff",
                                              border: "1px solid #ffffff",
                                              "text-align": "center",
                                              "line-height": "13px",
                                              "font-size": "12px"
                                            }
                                          },
                                          [_vm._v(_vm._s(item.orderNum))]
                                        )
                                      : _c(
                                          "span",
                                          { staticStyle: { color: "#ffffff" } },
                                          [_vm._v("·")]
                                        ),
                                    _c(
                                      "p",
                                      {
                                        staticStyle: {
                                          color: "#ffffff",
                                          "font-size": "12px"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n                 " +
                                            _vm._s(item.signatoryFullName) +
                                            "\n              "
                                        )
                                      ]
                                    )
                                  ]
                                )
                              }),
                              _c(
                                "div",
                                [
                                  _c("p", { staticClass: "textEllipsis" }, [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(
                                          scope.row.signInfoVOS[0]
                                            .signatoryFullName
                                        ) +
                                        "\n              "
                                    )
                                  ]),
                                  scope.row.signInfoVOS.length > 1
                                    ? _c("p", { staticClass: "textEllipsis" }, [
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(
                                              scope.row.signInfoVOS[1]
                                                .signatoryFullName
                                            ) +
                                            "\n              "
                                        )
                                      ])
                                    : _vm._e(),
                                  [
                                    scope.row.signInfoVOS.length === 3
                                      ? _c(
                                          "p",
                                          { staticClass: "textEllipsis" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                scope.row.signInfoVOS[2]
                                                  .signatoryFullName
                                              )
                                            )
                                          ]
                                        )
                                      : _vm._e(),
                                    scope.row.signInfoVOS.length > 3
                                      ? _c(
                                          "p",
                                          { staticClass: "textEllipsis" },
                                          [_vm._v("···")]
                                        )
                                      : _vm._e()
                                  ]
                                ],
                                2
                              )
                            ],
                            2
                          )
                        ]
                      }
                    }
                  ],
                  null,
                  false,
                  2600961688
                )
              }),
              _c("el-table-column", {
                attrs: { label: "创建时间", prop: "createTime", width: "180" },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function(scope) {
                        return scope.row && scope.row.updateTime
                          ? [
                              _c(
                                "span",
                                {
                                  staticStyle: { color: "rgba(41, 2, 2, 0.65)" }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("formatDateHM")(
                                        scope.row.updateTime
                                      )
                                    )
                                  )
                                ]
                              )
                            ]
                          : undefined
                      }
                    }
                  ],
                  null,
                  true
                )
              }),
              _c("el-table-column", {
                attrs: { label: "操作", width: "100" },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function(scope) {
                        return !(
                          scope.row.applyNo &&
                          scope.row.applyNo.startsWith("APLO")
                        )
                          ? [
                              scope.row.coEditingId
                                ? [
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "color-success edit pointer",
                                        staticStyle: { "margin-right": "5px" },
                                        on: {
                                          click: function($event) {
                                            return _vm.drftEditOrDing(scope.row)
                                          }
                                        }
                                      },
                                      [_vm._v("继续编辑\n            ")]
                                    )
                                  ]
                                : [
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "color-success edit pointer",
                                        on: {
                                          click: function($event) {
                                            return _vm.elEdit(scope.row)
                                          }
                                        }
                                      },
                                      [_vm._v("编辑\n            ")]
                                    )
                                  ]
                            ]
                          : undefined
                      }
                    }
                  ],
                  null,
                  true
                )
              }),
              _c("no-data", {
                attrs: { slot: "empty", text: "暂无数据" },
                slot: "empty"
              })
            ],
            1
          )
        : _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading"
                }
              ],
              key: "typeOther",
              ref: "dataList",
              staticClass: "data-list",
              staticStyle: { "min-height": "54vh" },
              attrs: {
                data: _vm.tableList,
                "tooltip-effect": "dark",
                "expand-row-keys": _vm.expandKeys,
                "row-key": function(row) {
                  return row.applyId
                },
                "header-cell-style": {
                  background: "#f9f9f9",
                  color: "#333333",
                  fontWeight: "500"
                }
              },
              on: {
                "selection-change": _vm.handleSelectionChange,
                "cell-mouse-enter": _vm.cellMouseEnter,
                "cell-mouse-leave": _vm.cellMouseLeave
              }
            },
            [
              _c("el-table-column", {
                attrs: { type: "selection", width: "55" }
              }),
              _c("el-table-column", {
                attrs: { label: "文件名称" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c(
                          "div",
                          {
                            staticStyle: {
                              display: "flex",
                              "align-items": "center",
                              position: "relative",
                              "padding-top": "10px"
                            }
                          },
                          [
                            scope.row.files > 1
                              ? _c("span", { staticClass: "multiFile" }, [
                                  _vm._v("多")
                                ])
                              : _vm._e(),
                            _c("corp-apply-name", {
                              attrs: {
                                applyType: "applyList",
                                signInfo: {
                                  signStatus: scope.row.signStatus,
                                  selfSign: scope.row.selfSign,
                                  selfApprove: scope.row.selfApprove,
                                  signNo: scope.row.signNo,
                                  contractName: scope.row.contractName,
                                  applyNo: scope.row.applyNo,
                                  approveId: scope.row.approveId,
                                  multiFile: scope.row.multiFile,
                                  aiCorpUserIdFlag: scope.row.aiCorpUserIdFlag
                                }
                              }
                            }),
                            scope.row.vpresId
                              ? _c(
                                  "span",
                                  {
                                    staticClass: "color-success",
                                    staticStyle: {
                                      "font-size": "12px",
                                      color: "rgba(41, 2, 2, 0.65)",
                                      cursor: "default",
                                      flex: "1",
                                      "min-width": "150px",
                                      "padding-top": "5px"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "  备案号：" +
                                        _vm._s(scope.row.vpresId) +
                                        "\n              "
                                    )
                                  ]
                                )
                              : _vm._e()
                          ],
                          1
                        ),
                        _c("p", { staticClass: "textEllipsis" }, [
                          _vm._v("发起方：" + _vm._s(scope.row.ebqUserName))
                        ]),
                        _c(
                          "p",
                          { staticClass: "textEllipsis" },
                          [
                            _vm._v(
                              "\n            发起时间：" +
                                _vm._s(
                                  _vm._f("formatDateHM")(scope.row.createTime)
                                ) +
                                "\n            "
                            ),
                            _c(
                              "el-tooltip",
                              {
                                attrs: {
                                  effect: "dark",
                                  content: "由钉钉发起的",
                                  placement: "bottom-start"
                                }
                              },
                              [
                                scope.row.fromDingTalk &&
                                scope.row.fromDingTalk == 1 &&
                                !_vm.isInDingTalk
                                  ? _c("img", {
                                      attrs: {
                                        src: "/images/icon/dingIcon.png",
                                        alt: "钉钉",
                                        width: "20px"
                                      }
                                    })
                                  : _vm._e()
                              ]
                            )
                          ],
                          1
                        )
                      ]
                    }
                  }
                ])
              }),
              false
                ? _c("el-table-column", {
                    attrs: { label: "审批方", "show-overflow-tooltip": "" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              scope.row.signStatus === -3 ||
                              scope.row.signStatus === -4
                                ? _c("span", [
                                    _vm._v(
                                      "\n            " +
                                        _vm._s(scope.row.allApproveName) +
                                        "\n          "
                                    )
                                  ])
                                : _c("span", [_vm._v(" - ")])
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      3472288626
                    )
                  })
                : _vm._e(),
              _c("el-table-column", {
                attrs: { label: "签署方" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c(
                          "el-tooltip",
                          { attrs: { placement: "bottom-start" } },
                          [
                            _vm._l(scope.row.signInfoVOS, function(
                              item,
                              index
                            ) {
                              return _c(
                                "div",
                                {
                                  key: index,
                                  staticStyle: {
                                    display: "flex",
                                    "align-items": "center",
                                    "padding-bottom": "5px"
                                  },
                                  attrs: { slot: "content" },
                                  slot: "content"
                                },
                                [
                                  item.orderNum && item.orderNum >= 1
                                    ? _c(
                                        "span",
                                        {
                                          staticStyle: {
                                            display: "block",
                                            width: "13px",
                                            height: "13px",
                                            "border-radius": "50%",
                                            color: "#ffffff",
                                            border: "1px solid #ffffff",
                                            "text-align": "center",
                                            "line-height": "13px",
                                            "font-size": "12px"
                                          }
                                        },
                                        [_vm._v(_vm._s(item.orderNum))]
                                      )
                                    : _c(
                                        "span",
                                        { staticStyle: { color: "#ffffff" } },
                                        [_vm._v("·")]
                                      ),
                                  _c(
                                    "div",
                                    {
                                      staticStyle: {
                                        color: "#ffffff",
                                        "font-size": "12px"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                【" +
                                          _vm._s(
                                            item.signStatus === 0 ||
                                              item.signStatus === -1
                                              ? "未签署"
                                              : item.signStatus === 1
                                              ? "已签署"
                                              : "已拒签"
                                          ) +
                                          "】\n              "
                                      )
                                    ]
                                  ),
                                  _c(
                                    "p",
                                    {
                                      staticStyle: {
                                        color: "#ffffff",
                                        "font-size": "12px"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(item.signatoryFullName) +
                                          "\n              "
                                      )
                                    ]
                                  )
                                ]
                              )
                            }),
                            _c(
                              "div",
                              [
                                _c("p", { staticClass: "textEllipsis" }, [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(
                                        scope.row.signInfoVOS[0]
                                          .signatoryFullName
                                      ) +
                                      "\n              "
                                  )
                                ]),
                                scope.row.signInfoVOS.length > 1
                                  ? _c("p", { staticClass: "textEllipsis" }, [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(
                                            scope.row.signInfoVOS[1]
                                              .signatoryFullName
                                          ) +
                                          "\n              "
                                      )
                                    ])
                                  : _vm._e(),
                                [
                                  scope.row.signInfoVOS.length === 3
                                    ? _c("p", { staticClass: "textEllipsis" }, [
                                        _vm._v(
                                          _vm._s(
                                            scope.row.signInfoVOS[2]
                                              .signatoryFullName
                                          )
                                        )
                                      ])
                                    : _vm._e(),
                                  scope.row.signInfoVOS.length > 3
                                    ? _c("p", { staticClass: "textEllipsis" }, [
                                        _vm._v("···")
                                      ])
                                    : _vm._e()
                                ]
                              ],
                              2
                            )
                          ],
                          2
                        )
                      ]
                    }
                  }
                ])
              }),
              _c("el-table-column", {
                attrs: {
                  label: "状态",
                  width: "100",
                  "show-overflow-tooltip": ""
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        scope.row.signStatus === -3
                          ? [
                              scope.row.selfApprove === 1
                                ? _c("span", { staticClass: "red" }, [
                                    _vm._v("待我审")
                                  ])
                                : _c("span", { staticClass: "blue" }, [
                                    _vm._v("待ta审")
                                  ])
                            ]
                          : scope.row.signStatus === -4
                          ? [
                              _c("p", { staticClass: "orange" }, [
                                _vm._v("审批驳回")
                              ])
                            ]
                          : scope.row.signStatus === 0
                          ? [
                              scope.row.selfSign === 1
                                ? _c("p", { staticClass: "red" }, [
                                    _vm._v("待我签")
                                  ])
                                : _c("p", { staticClass: "blue" }, [
                                    _vm._v("待ta签")
                                  ])
                            ]
                          : scope.row.signStatus === 1
                          ? [
                              _c("span", { staticClass: "green" }, [
                                _vm._v("已完成")
                              ])
                            ]
                          : scope.row.signStatus === 2
                          ? [
                              _c("span", { staticClass: "orange" }, [
                                _vm._v("已拒签")
                              ])
                            ]
                          : scope.row.signStatus === -5
                          ? [
                              _c("span", { staticClass: "grey" }, [
                                _vm._v("已撤销")
                              ])
                            ]
                          : scope.row.signStatus === -6
                          ? [
                              _c("span", { staticClass: "grey" }, [
                                _vm._v("已过期")
                              ])
                            ]
                          : _vm._e()
                      ]
                    }
                  }
                ])
              }),
              _c("el-table-column", {
                attrs: { label: "操作", width: "180" },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function(scope) {
                        return !(
                          scope.row.applyNo &&
                          scope.row.applyNo.startsWith("APLO")
                        )
                          ? [
                              scope.row.signStatus !== 1
                                ? _c("corp-handles", {
                                    ref: "handlesComp",
                                    attrs: {
                                      rowData: scope.row,
                                      applyType: "applyList"
                                    },
                                    on: { resetList: _vm.getSignLists }
                                  })
                                : _vm._e(),
                              scope.row.signStatus === 1
                                ? [
                                    _c("existing-evidence", {
                                      attrs: { rowData: scope.row },
                                      on: {
                                        copyTextToQueryEmit: _vm.copyTextToQuery
                                      }
                                    }),
                                    _c(
                                      "el-dropdown",
                                      {
                                        attrs: { trigger: "click" },
                                        on: {
                                          "visible-change": function($event) {
                                            return _vm.visiChange(
                                              $event,
                                              scope.row.applyId
                                            )
                                          }
                                        }
                                      },
                                      [
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "com-normal-btn pointer"
                                          },
                                          [
                                            _vm._v(
                                              "\n                更多操作\n                "
                                            ),
                                            _c("i", {
                                              staticClass:
                                                "com-normal-btn el-icon--right",
                                              class:
                                                _vm.visiDown.status &&
                                                _vm.visiDown.rowApplyId ==
                                                  scope.row.applyId
                                                  ? "el-icon-caret-top"
                                                  : "el-icon-caret-bottom"
                                            })
                                          ]
                                        ),
                                        _c(
                                          "el-dropdown-menu",
                                          {
                                            staticStyle: {
                                              "background-color": "#f5f6f6"
                                            },
                                            attrs: { slot: "dropdown" },
                                            slot: "dropdown"
                                          },
                                          [
                                            _c("more-button", {
                                              attrs: {
                                                rowData: scope.row,
                                                showMoreBtn: true
                                              },
                                              on: {
                                                btnMethodFn: _vm.openLYDialog
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ]
                                : _vm._e()
                            ]
                          : undefined
                      }
                    }
                  ],
                  null,
                  true
                )
              }),
              _c("no-data", {
                attrs: { slot: "empty", text: "暂无数据" },
                slot: "empty"
              })
            ],
            1
          ),
      _vm.batchLength && false
        ? _c("div", { staticClass: "bulkOperation" }, [
            _vm._v("\n      已选" + _vm._s(_vm.batchLength) + "份文件\n    ")
          ])
        : _vm._e(),
      _c(
        "el-row",
        { staticClass: "pageation row" },
        [
          _c(
            "el-col",
            { attrs: { span: 5 } },
            [
              _vm.$route.query.directoryId
                ? [
                    _c(
                      "el-button",
                      {
                        attrs: { size: "small" },
                        on: {
                          click: function($event) {
                            return _vm.emitFn("dirMove")
                          }
                        }
                      },
                      [_vm._v("归档")]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { size: "small" },
                        on: {
                          click: function($event) {
                            return _vm.emitFn("removeFromDir")
                          }
                        }
                      },
                      [_vm._v("移除")]
                    )
                  ]
                : _vm._e(),
              _vm.$route.query.notMeSign
                ? [
                    _c(
                      "el-button",
                      {
                        attrs: { size: "small" },
                        on: {
                          click: function($event) {
                            return _vm.emitFn("saveToDir")
                          }
                        }
                      },
                      [_vm._v("归档")]
                    )
                  ]
                : _vm._e(),
              _vm.$route.query.signStatus === "4"
                ? [
                    _c(
                      "el-button",
                      {
                        attrs: { size: "mini" },
                        on: {
                          click: function($event) {
                            return _vm.emitFn("deleteFromDir")
                          }
                        }
                      },
                      [_vm._v("删除")]
                    )
                  ]
                : _vm._e(),
              _vm.$route.query.signStatus !== "4"
                ? _c(
                    "el-button",
                    {
                      attrs: { size: "small" },
                      on: {
                        click: function($event) {
                          return _vm.selectCcUserFn()
                        }
                      }
                    },
                    [_vm._v("抄送")]
                  )
                : _vm._e()
            ],
            2
          ),
          _c(
            "el-col",
            { staticClass: "page-flex-end", attrs: { span: 19 } },
            [
              _c("el-pagination", {
                attrs: {
                  "current-page": _vm.queryParam.itemPage,
                  "pager-count": 5,
                  "page-sizes": [10, 20, 50, 100],
                  "page-size": _vm.queryParam.pageSize,
                  layout: "sizes, prev, pager, next, total",
                  total: _vm.queryParam.total
                },
                on: {
                  "size-change": _vm.handleSizeChange,
                  "current-change": _vm.handleCurrentChange
                }
              }),
              _c("el-go", {
                attrs: {
                  "page-size": _vm.queryParam.pageSize,
                  total: _vm.queryParam.total
                },
                on: { "current-change": _vm.handleCurrentChange }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "选择签署方",
            visible: _vm.visibleNoSignList,
            "modal-append-to-body": "",
            "append-to-body": "",
            "close-on-click-modal": false,
            "show-close": false,
            width: "550px"
          },
          on: {
            "update:visible": function($event) {
              _vm.visibleNoSignList = $event
            }
          }
        },
        [
          _vm.noSign.data
            ? _c(
                "el-row",
                _vm._l(_vm.noSign.data, function(item, index) {
                  return _c(
                    "el-col",
                    {
                      key: index,
                      staticClass: "font-ellipsis",
                      staticStyle: { "margin-bottom": "10px" },
                      attrs: { span: 8 }
                    },
                    [
                      _c(
                        "a",
                        {
                          staticClass: "color-success",
                          attrs: {
                            title: item.fullName,
                            href: "javascript:void (0)"
                          },
                          on: {
                            click: function($event) {
                              return _vm.getNoSignUrl(item)
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm._f("ellipsis")(item.fullName, 8)))]
                      )
                    ]
                  )
                }),
                1
              )
            : _vm._e(),
          _c(
            "p",
            { staticClass: "text-right" },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "small" },
                  on: {
                    click: function($event) {
                      _vm.visibleNoSignList = false
                    }
                  }
                },
                [_vm._v("取消\n        ")]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.visibleNoSignUrl,
            "modal-append-to-body": "",
            "append-to-body": "",
            width: "340px"
          },
          on: {
            "update:visible": function($event) {
              _vm.visibleNoSignUrl = $event
            }
          }
        },
        [
          _vm.noSign.url
            ? _c(
                "div",
                { staticClass: "text-center nosign-url" },
                [
                  _c("p", [_vm._v(_vm._s(_vm.noSign.name) + "的签署链接")]),
                  _c("qrcode", {
                    key: "evidence",
                    attrs: { value: _vm.noSign.url, size: 200, leave: "H" }
                  }),
                  _c("p", { staticStyle: { "margin-bottom": "10px" } }, [
                    _vm._v(_vm._s(_vm.noSign.url))
                  ]),
                  _c(
                    "p",
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "success", size: "small" },
                          on: {
                            click: function($event) {
                              _vm.visibleNoSignUrl = false
                            }
                          }
                        },
                        [_vm._v("确定\n          ")]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e()
        ]
      ),
      _c("div", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.batchLoading,
            expression: "batchLoading"
          },
          {
            name: "loading",
            rawName: "v-loading",
            value: _vm.batchLoading,
            expression: "batchLoading"
          }
        ],
        staticStyle: {
          position: "fixed",
          left: "0",
          top: "0",
          right: "0",
          bottom: "0",
          "z-index": "1900"
        },
        attrs: {
          "element-loading-text": "合同发起中，请勿关闭当前页面",
          "element-loading-spinner": "el-icon-loading",
          "element-loading-background": "rgba(0, 0, 0, 0.5)"
        }
      }),
      _c("tag-manage", {
        ref: "tagManage",
        attrs: { isCrop: true },
        on: { close: _vm.getTagList, refresh: _vm.getSignLists }
      }),
      _c(
        "el-dialog",
        {
          staticClass: "ly-info",
          attrs: {
            title: "履约文件",
            visible: _vm.lYDialogVisible,
            width: "850px"
          },
          on: {
            "update:visible": function($event) {
              _vm.lYDialogVisible = $event
            }
          }
        },
        [
          _c(
            "el-tabs",
            {
              staticClass: "ly-mask",
              on: { "tab-click": _vm.handleClick },
              model: {
                value: _vm.activeName,
                callback: function($$v) {
                  _vm.activeName = $$v
                },
                expression: "activeName"
              }
            },
            [
              _c("el-tab-pane", { attrs: { label: "上传原文件", name: "1" } }, [
                _c("p", { staticClass: "tips" }, [
                  _vm._v(
                    "\n            支持常见图片、文档、视频、音频、压缩包格式，上传后会保存原文件，单个文件大小不超过30MB\n          "
                  )
                ]),
                _c(
                  "div",
                  { staticClass: "box-wrap" },
                  [
                    _c("div", { staticClass: "temone add" }, [
                      _c("span", { staticClass: "el-icon-plus" }),
                      _c("input", {
                        ref: "referenceUpload",
                        staticClass: "file-ipt",
                        attrs: { type: "file" },
                        on: { change: _vm.handleInputChange }
                      })
                    ]),
                    _vm._l(_vm.lYDialogData, function(item, idx) {
                      return _c("div", { key: idx, staticClass: "temone" }, [
                        _c("div", { staticClass: "t-box" }, [
                          _c("img", {
                            staticClass: "y-img",
                            attrs: { src: "/images/web/file-icon.png" }
                          }),
                          _c("div", { staticClass: "msk" }, [
                            _c("span", { staticClass: "des" }, [
                              _vm._v(
                                "上传人：" +
                                  _vm._s(item.userName) +
                                  " -" +
                                  _vm._s(item.accountName)
                              )
                            ])
                          ])
                        ]),
                        _c("div", { staticClass: "a-btn" }, [
                          _c(
                            "a",
                            {
                              staticClass: "has-hover",
                              attrs: { href: _vm.downloadLYFile(item.file) }
                            },
                            [_vm._v("下载")]
                          ),
                          _vm.isDoc(item)
                            ? _c(
                                "a",
                                {
                                  staticClass: "has-hover",
                                  on: {
                                    click: function($event) {
                                      return _vm.previewDoc(item)
                                    }
                                  }
                                },
                                [_vm._v("预览")]
                              )
                            : _vm._e(),
                          _vm.isVideoOrImg(item)
                            ? _c(
                                "a",
                                {
                                  staticClass: "has-hover",
                                  on: {
                                    click: function($event) {
                                      return _vm.previewVideOrImg(item)
                                    }
                                  }
                                },
                                [_vm._v("预览")]
                              )
                            : _vm._e(),
                          item.canDelete
                            ? _c(
                                "a",
                                {
                                  staticClass: "has-hover",
                                  on: {
                                    click: function($event) {
                                      return _vm.delLYFile(item)
                                    }
                                  }
                                },
                                [_vm._v("删除")]
                              )
                            : _vm._e(),
                          _c("a", { staticClass: "no-hover" }, [
                            _vm._v(_vm._s(item.fileName))
                          ])
                        ])
                      ])
                    })
                  ],
                  2
                )
              ]),
              _c(
                "el-tab-pane",
                { attrs: { label: "上传文件哈希", name: "2" } },
                [
                  _c("p", { staticClass: "tips" }, [
                    _vm._v(
                      "\n            格式没有限制，仅保存上传文件的特征值（哈希），不对文件本身做保存，单个文件大小不超过500M\n          "
                    )
                  ]),
                  _c(
                    "div",
                    { staticClass: "box-wrap" },
                    [
                      _c("div", { staticClass: "temone add" }, [
                        _c("span", { staticClass: "el-icon-plus" }),
                        _c("input", {
                          ref: "referenceUpload1",
                          staticClass: "file-ipt",
                          attrs: { type: "file" },
                          on: { change: _vm.handleInputChange }
                        })
                      ]),
                      _vm._l(_vm.lYDialogData, function(item, idx) {
                        return _c("div", { key: idx, staticClass: "temone" }, [
                          _c("div", { staticClass: "t-box" }, [
                            _c("img", {
                              staticClass: "y-img",
                              attrs: { src: "/images/web/hash-icon.png" }
                            }),
                            _c("div", { staticClass: "msk" }, [
                              _c("span", { staticClass: "des" }, [
                                _vm._v(
                                  "上传人：" +
                                    _vm._s(item.userName) +
                                    " -" +
                                    _vm._s(item.accountName)
                                )
                              ]),
                              _c("br"),
                              _c(
                                "span",
                                {
                                  staticClass: "des",
                                  staticStyle: { margin: "0" }
                                },
                                [_vm._v("备案号：" + _vm._s(item.presId))]
                              )
                            ])
                          ]),
                          _c("div", { staticClass: "a-btn" }, [
                            _c(
                              "a",
                              {
                                staticClass: "has-hover",
                                on: {
                                  click: function($event) {
                                    return _vm.validLYFile(item)
                                  }
                                }
                              },
                              [_vm._v("验证")]
                            ),
                            item.canDelete
                              ? _c(
                                  "a",
                                  {
                                    staticClass: "has-hover",
                                    on: {
                                      click: function($event) {
                                        return _vm.delLYFile(item)
                                      }
                                    }
                                  },
                                  [_vm._v("删除")]
                                )
                              : _vm._e(),
                            _c("a", { staticClass: "no-hover" }, [
                              _vm._v(_vm._s(item.fileName))
                            ])
                          ])
                        ])
                      })
                    ],
                    2
                  )
                ]
              )
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c("span", { staticClass: "num" }, [
                _vm._v("文件数："),
                _c("label", [_vm._v(_vm._s(_vm.lYDialogData.length))]),
                _vm._v("个")
              ]),
              _c(
                "el-button",
                {
                  staticClass: "cancel-btn",
                  attrs: { type: "primary", size: "small" },
                  on: {
                    click: function($event) {
                      _vm.lYDialogVisible = false
                    }
                  }
                },
                [_vm._v("关闭")]
              )
            ],
            1
          )
        ],
        1
      ),
      _c("ViewFilesToDoc", {
        attrs: {
          visibleShow: _vm.visibleShowEnclosureDoc,
          enclosurePreviewNumItem: _vm.enclosurePreviewNumItem
        },
        on: { setViewFilesToDocDialogData: _vm.onSetViewFilesToDocDialogData }
      }),
      _c("ViewFilesToImg", {
        staticStyle: { "text-align": "center" },
        attrs: {
          visibleShow: _vm.visibleShowEnclosure,
          isRefresh: _vm.isRefresh,
          enclosurePreviewNumItem: _vm.enclosurePreviewNumItem,
          imgList: _vm.getEnclosureImgList
        },
        on: { setViewFilesToImgDialogData: _vm.onSetViewFilesToImgDialogData }
      }),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.nodeQueryVisible,
            "custom-class": "data-dialog",
            width: "800px",
            "destroy-on-close": ""
          },
          on: {
            "update:visible": function($event) {
              _vm.nodeQueryVisible = $event
            }
          }
        },
        [
          _c(
            "div",
            {
              staticClass: "node_header",
              attrs: { slot: "title" },
              slot: "title"
            },
            [_vm._v("保全链节点查询")]
          ),
          _c("p", { staticStyle: { padding: "10px" } }, [
            _vm._v("当前合同备案号：" + _vm._s(_vm.vpresId))
          ]),
          _c("node-query", { attrs: { vpresId: _vm.vpresId } })
        ],
        1
      ),
      _c("selectCcUser", {
        ref: "selectCcUserRef",
        attrs: { applyNosArr: _vm.applyNosArr },
        on: { clearListFn: _vm.clearListFn }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-25261dc4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-25261dc4","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./pages/corp/signInfo/applyList.vue
// module id = Mrkr
// module chunks = 42